/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VersionInfo } from '../models/VersionInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VersionService {

    /**
     * Текущая версия бэкенда из ENV переменных сборки
     * @returns VersionInfo
     * @throws ApiError
     */
    public static versionRetrieve(): CancelablePromise<VersionInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/version/',
        });
    }

}
